export const STAGGER_DURATION = 100;
export default {
  transition: {
    transition: `opacity 600ms cubic-bezier(0.23, 1, 0.32, 1), transform 450ms cubic-bezier(0.23, 1, 0.32, 1)`,
  },
};
